import { Chip } from '@components/catalog/chip-list/chip-list';
import React, { useEffect, useState } from 'react';
import Badge from '@components/common/badge/badge';
import Icon from '@components/atoms/icon/icon';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import styles from './expand-chips-wrapper.module.scss';

const MAX_NUMBER_OF_CHIPS = 5;

const ExpandChipsBadge: React.FC<{
  chips: Chip[];
  setShowAllChips: React.Dispatch<React.SetStateAction<boolean>>;
  showAllChips: boolean;
}> = ({ chips, setShowAllChips, showAllChips }) => {
  const additionalChipsCount = chips.length - MAX_NUMBER_OF_CHIPS;
  const { t } = useTranslation();

  useEffect(() => {
    // reset showAllChips to false when badge unmounts
    return () => setShowAllChips(false);
  }, []);

  return (
    <Badge
      useFilterRedesignUi={true}
      onClick={() => setShowAllChips((prev) => !prev)}
    >
      <span className={styles.badgeContent}>
        {showAllChips
          ? t('CATALOG.FILTER_CHIPS.SEE_LESS')
          : t('CATALOG.FILTER_CHIPS.SEE_MORE', {
              filterCount: additionalChipsCount,
            })}
        <Icon
          className={clsx(styles.badgeContent__arrowIcon, showAllChips && styles.badgeContent__arrowIcon__expanded)}
          name={`arrow-head-down`}
        />
      </span>
    </Badge>
  );
};

const ExpandChipsWrapper = ({
  chips,
  children,
}: {
  chips: Chip[];
  children: (chips: Chip[]) => React.ReactElement;
}) => {
  const [showAllChips, setShowAllChips] = useState<boolean>(false);

  const showExpandChipsButton = chips.length > MAX_NUMBER_OF_CHIPS;
  const chipsToRender = showAllChips ? chips : chips.slice(0, MAX_NUMBER_OF_CHIPS);
  return (
    <>
      {children(chipsToRender)}
      {showExpandChipsButton && (
        <ExpandChipsBadge
          chips={chips}
          setShowAllChips={setShowAllChips}
          showAllChips={showAllChips}
        />
      )}
    </>
  );
};

export default ExpandChipsWrapper;
